import axios from 'axios';
import api from './client'; // Import the shared client

// Helper to get the user's current timezone string (e.g., "America/New_York")
const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


export function markGoalDoneToday(goalId) {
  // Pass timezone as a query param
  return api.post(`/goals/${goalId}/checks`, null, {
    params: { timeZone: userTimeZone }
  });
}



export function toggleGoalDoneToday(goalId) {
  return api.post(`/users/goals/${goalId}/checks/today/toggle`, null, {
    params: { timeZone: userTimeZone }
  });
}

export function getGoalChecks(goalId, from, to) {
  return api.get(`/users/goals/${goalId}/checks`, {
    params: { from, to, timeZone: userTimeZone },
  });
}

export function getGlobalContributions(from, to) {
  return api.get('/users/calendar/contributions', {
    params: { from, to, timeZone: userTimeZone },
  });
}

export function getGoalDoneToday(goalId) {
  return api.get(`/users/goals/${goalId}/checks/today`, {
    params: { timeZone: userTimeZone }
  });
}